<div class="FContainer">
  <mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
  <div class="FContainer">
    <h3 class="FContainer__title">{{ title }}</h3>
  </div>
  <div class="col-md-12 p-5">
    <ng-container *ngIf="requirementsErrorMessage && showAlert">
      <kt-alert type="warn" [showCloseButton]="true" (close)="showAlert = false">
        <div [innerHTML]="requirementsErrorMessage"></div>
      </kt-alert>
    </ng-container>
    <div>
      <div class="col-cols-4 !pb-1" *ngIf="settings?.is_active">
        <mat-label>{{ "TASKS.VIEW.CREDIT_APPROVAL.ASSIGNEE" | translate }}</mat-label>
        <mat-form-field class="mat-form-field-fluid">
          <mat-select
            [formControl]="credit_approval_user"
            [placeholder]="'TASKS.VIEW.CREDIT_APPROVAL.ASSIGNEE' | translate"
          >
            <mat-option [value]="user.id" *ngFor="let user of creditApprovalUsers">
              {{ user.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="secondCustomer; else renderOneClientStepper">
        <mat-stepper #stepper class="FContainer__stepper" labelPosition="bottom">
          <mat-step [stepControl]="step1.customerForm" [errorMessage]="'GENERAL.FILL_MISSING_FIELDS' | translate">
            <ng-template matStepLabel
              >{{ customerTypesLabel.get(firstCustomer.customer_type) | translate }} Kundedetaljer
            </ng-template>
            <kt-customer-step
              [isIdentifcationNumberRequired]="true"
              [customerInfo]="firstCustomer"
              #step1
              (customerErrorsSubject)="mainCustomerHasErrors($event)"
              (customerFormValueChanged)="setFirstCustomerValue($event)"
            >
            </kt-customer-step>
          </mat-step>
          <!-- second customer -->
          <mat-step [stepControl]="step2.customerForm" [errorMessage]="'GENERAL.FILL_MISSING_FIELDS' | translate">
            <ng-template matStepLabel
              >{{ customerTypesLabel.get(secondCustomer.customer_type) | translate }}
              Kundedetaljer
            </ng-template>
            <kt-customer-step
              [customerInfo]="secondCustomer"
              #step2
              [isIdentifcationNumberRequired]="true"
              (customerErrorsSubject)="secondCustomerHasErrors($event)"
              (customerFormValueChanged)="setSecondCustomerValue($event)"
            >
            </kt-customer-step>
          </mat-step>

          <!-- vehicle form-->
          <mat-step [stepControl]="step3.vehicleForm" [errorMessage]="'GENERAL.FILL_MISSING_FIELDS' | translate">
            <ng-template matStepLabel>Køretøjsdetaljer</ng-template>
            <kt-vehicle-step
              [vehicleInfo]="vehicle"
              #step3
              (vehicleErrorsSubject)="vehicleFormHasErrors($event)"
            ></kt-vehicle-step>
            <div mat-dialog-actions align="end">
              <button mat-button matStepperPrevious>Back</button>

              <button
                *ngIf="secondCustomer"
                [ngClass]="isSubmitted ? '' : 'bg-primary text-white'"
                (click)="
                  onSubmit({
                    firstCustomer: step1.customerForm.value,
                    secondCustomer: step2.customerForm.value,
                    vehicle: step3.vehicleForm.value,
                    mileagePhoto: step3.uploadMileagePhoto,
                    creditApprovalAssignee: credit_approval_user.value
                  })
                "
                [disabled]="isSubmitted"
                mat-button
                color="primary"
              >
                Submit
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </ng-container>
      <ng-template #renderOneClientStepper>
        <mat-stepper #stepper class="FContainer__stepper" labelPosition="bottom">
          <mat-step [stepControl]="step1.customerForm" [errorMessage]="'GENERAL.FILL_MISSING_FIELDS' | translate">
            <ng-template matStepLabel
              >{{ customerTypesLabel.get(firstCustomer.customer_type) | translate }} Kundedetaljer
            </ng-template>
            <kt-customer-step
              [isIdentifcationNumberRequired]="true"
              [customerInfo]="firstCustomer"
              #step1
              (customerErrorsSubject)="mainCustomerHasErrors($event)"
              (customerFormValueChanged)="setFirstCustomerValue($event)"
            >
            </kt-customer-step>
          </mat-step>
          <!--    vehicle form-->
          <mat-step [stepControl]="step3.vehicleForm" [errorMessage]="'GENERAL.FILL_MISSING_FIELDS' | translate">
            <ng-template matStepLabel>Køretøjsdetaljer</ng-template>
            <kt-vehicle-step
              [vehicleInfo]="vehicle"
              #step3
              (vehicleErrorsSubject)="vehicleFormHasErrors($event)"
            ></kt-vehicle-step>
            <div mat-dialog-actions align="end">
              <button mat-button matStepperPrevious>Back</button>

              <button
                *ngIf="!secondCustomer"
                [ngClass]="isSubmitted ? '' : 'bg-primary text-white'"
                (click)="
                  onSubmit({
                    firstCustomer: step1.customerForm.value,
                    vehicle: step3.vehicleForm.value,
                    mileagePhoto: step3.uploadMileagePhoto,
                    creditApprovalAssignee: credit_approval_user.value
                  })
                "
                mat-button
                [disabled]="isSubmitted"
                color="primary"
              >
                Submit
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </ng-template>
    </div>
  </div>
</div>
